<template>
  <new-vehicle />
</template>

<script>
import NewVehicle from "@/components/3pl/Settings/Vehicles/NewVehicle/index";
export default {
  components: {
    NewVehicle,
  },
};
</script>
<style></style>
